
export default class Timer {
    static repeat(duration, callback) {
        let subscriptionKey = null;

        subscriptionKey = setInterval(callback, duration)

        return () => clearInterval(subscriptionKey)
    }
}